module.exports = __webpack_public_path__ + "static/media/male1.3ec3891b.png";